<div [formGroup]="otpForm">

  <div>
    <div class="fx-layout-align-start-m fx-layout-row">
      <button (click)="goBack()" class="back-button" mat-raised-button color="primary">Back to Login</button>
    </div>
  </div>

  <div class="card">
    <div class="icon-wrapper">
      <mat-icon style="font-size: 48px; color: #dc385f;" class="icon icon-circle">security</mat-icon>
    </div>

    <h3>Two Factor Authentication</h3>
    <p class="subtitle">
      Enter 6-digit code from your Authenticator App.
    </p>

    <div class="otp-container">
      @for (ctrl of otpForm.controls | keyvalue; track ctrl; let i = $index) {
        <input #F type="text" placeholder="0"
          inputmode="numeric"
          autocomplete="one-time-code" [formControlName]="'d' + i"
          (keydown)="onKeyDown($event, i)"
          (input)="onInput($event, i)" />
      }
    </div>

    <p class="subtitle">
      If you've lost access to your Authenticator App, please click "Forgotten your login details?"
    </p>

  </div>
</div>